// agents/src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getCurrentMarket } from './config/markets';

// Importar traducciones
import translationEN from './locales/en.json';
import translationIT from './locales/it.json';
import translationES from './locales/es.json';

// Obtener idioma del mercado configurado
const market = getCurrentMarket();

// Intentar cargar idioma guardado en localStorage, si no existe usar el del mercado
const savedLanguage = localStorage.getItem('language');
const defaultLanguage = savedLanguage || market.nativeLanguage; // 'it', 'es', o 'en'

// Recursos de traducción
const resources = {
  en: {
    translation: translationEN
  },
  it: {
    translation: translationIT
  },
  es: {
    translation: translationES
  }
};

i18n
  .use(initReactI18next) // Pasa i18n a react-i18next
  .init({
    resources,
    lng: defaultLanguage, // Idioma por defecto según mercado o guardado
    fallbackLng: 'en', // Idioma de respaldo si no encuentra traducción
    interpolation: {
      escapeValue: false // React ya escapa por defecto
    },
    react: {
      useSuspense: false // Deshabilitar suspense para evitar problemas con React 19
    }
  });

export default i18n;
